import { css } from '@emotion/react';

export const contentCss = ({ color }) => css`
  color: ${color.surveyText};
  padding-bottom: 24px;
`;
